import {logUtil} from "@repo/lib-common";
import {DomainSubject} from "./domainSubject";

export class WindowUrlChangedSubject extends DomainSubject<Event>{
    name = "WindowUrlChangedSubject";
    init=()=>{
        window?.addEventListener("popstate",(event)=>{
            logUtil.consoleLog("popstate",event)
            this.trigger();
        });
        window?.addEventListener("hashchange",(event)=>{
            logUtil.consoleLog("hashchange",event)
            this.trigger();
        });
    }
}

const windowUrlChangedSubject=new WindowUrlChangedSubject();
windowUrlChangedSubject.activate();
export {windowUrlChangedSubject};
